import { lang } from '../lang'

export function isEmail(email) {
  const regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
  if (!regexp.test(email)) {
    return lang('q57')
  }
  return true
}
